import { CountryCodes } from '../../enums';

export const regionCountryCode = (
  country: string
): CountryCodes | undefined => {
  const countryLower = country.toLowerCase();
  switch (countryLower) {
    case 'united states':
      return CountryCodes.US;
    case 'united kingdom':
      return CountryCodes.GB;
    case 'sweden':
      return CountryCodes.SE;
    case 'austria':
      return CountryCodes.AT;
    case 'belgium':
      return CountryCodes.BE;
    case 'croatia':
      return CountryCodes.HR;
    case 'cyprus':
      return CountryCodes.CY;
    case 'estonia':
      return CountryCodes.EE;
    case 'finland':
      return CountryCodes.FI;
    case 'france':
      return CountryCodes.FR;
    case 'germany':
      return CountryCodes.DE;
    case 'greece':
      return CountryCodes.GR;
    case 'ireland':
      return CountryCodes.IE;
    case 'italy':
      return CountryCodes.IT;
    case 'latvia':
      return CountryCodes.LV;
    case 'lithuania':
      return CountryCodes.LT;
    case 'luxembourg':
      return CountryCodes.LU;
    case 'malta':
      return CountryCodes.MT;
    case 'netherlands':
      return CountryCodes.NL;
    case 'portugal':
      return CountryCodes.PT;
    case 'slovakia':
      return CountryCodes.SK;
    case 'slovenia':
      return CountryCodes.SI;
    case 'spain':
      return CountryCodes.ES;
    default:
      return undefined;
  }
};
